import React from 'react';
import type { WCardSuiteSummaryView } from '@zola/svc-web-api-ts-client';
import { UserContext } from '@zola-helpers/client/dist/types/@types';
import {
  TableNumberCollections,
  PlaceCardCollections,
  MenusCollections,
  ProgramsCollections,
} from './collections';

import { FeaturedDesignContainer, Grid } from './FeaturedDesign.style';
import { SuiteList } from '../UniversalLanding/SuiteList';

export interface FeaturedDesignProps {
  tableNumberSuites: WCardSuiteSummaryView[];
  placeCardSuites: WCardSuiteSummaryView[];
  menusSuites: WCardSuiteSummaryView[];
  programsSuites: WCardSuiteSummaryView[];
  userContext: UserContext;
}

export const FeaturedDesign: React.FC<FeaturedDesignProps> = ({
  tableNumberSuites,
  placeCardSuites,
  menusSuites,
  programsSuites,
}) => (
  <FeaturedDesignContainer>
    <Grid>
      <SuiteList
        title={
          <>
            Beautiful <span>table numbers</span>
          </>
        }
        cta="See table numbers"
        link="/wedding-planning/table-numbers/shop"
        suites={tableNumberSuites}
        collections={TableNumberCollections}
        position="head"
      />
      <SuiteList
        title={
          <>
            Charming <span>place cards</span>
          </>
        }
        cta="See place cards"
        link="/wedding-planning/place-cards/shop"
        suites={placeCardSuites}
        collections={PlaceCardCollections}
        position="tail"
      />

      <SuiteList
        title={
          <>
            Tempting <span>menus</span>
          </>
        }
        cta="See menus"
        link="/wedding-planning/menus/shop"
        suites={menusSuites}
        collections={MenusCollections}
        position="head"
      />

      <SuiteList
        title={
          <>
            Captivating <span>programs</span>
          </>
        }
        cta="See programs"
        link="/wedding-planning/programs/shop"
        suites={programsSuites}
        collections={ProgramsCollections}
        position="tail"
      />
    </Grid>
  </FeaturedDesignContainer>
);
